import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { enqueueSnackbar } from 'notistack';

import theme from '@/constants/theme';
import Button from '@/components/input/Button';
import { Route } from '@/services/routes/route.vm';
import Dialog from '@/components/dataDisplay/Dialog';
import { contentsService } from '@/services/contents';
import { Content } from '@/services/contents/content.vm';
import useLearningContents from '@/context/contents/hook';
import { Stage } from '@/services/stages/stage.vm';

interface DeleteButtonProps {
  loading: boolean;
  contentId: Content['id'];
  routeId?: Route['id'];
  stageId?: Stage['id'];
  isStageContent?: boolean;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  contentId,
  routeId,
  stageId,
  loading,
  isStageContent,
}) => {
  const [open, setOpen] = useState(false);
  const { deleteLearningContent, deleteStageContent } = useLearningContents();
  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDelete: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    const service = contentsService.deleteContent;
    service(contentId)
      .then(() => {
        if (!routeId) return;
        if (isStageContent && stageId) {
          deleteStageContent(routeId, stageId, contentId);
        } else {
          deleteLearningContent(routeId, contentId);
        }
        navigate(-1);
        enqueueSnackbar('Contenido eliminado correctamente', {
          variant: 'success',
        });
      })
      .catch((error) => {
        console.error('Error deleting content', error);
        enqueueSnackbar('Error al eliminar contenido', {
          variant: 'error',
        });
      });
  };

  return (
    <>
      <Button type="button" variant="danger" onClick={handleOpen} disabled={loading}>
        Eliminar Contenido
      </Button>
      <Dialog open={open} setOpen={setOpen}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: 8,
          }}
        >
          <h3
            style={{
              color: theme.colors.text.title,
            }}
          >
            ¿Estás seguro de que deseas eliminar este contenido?
          </h3>
          <p>Es posible que los archivos o las interacciones de los usuarios se eliminen también.</p>
          <p>{contentId}</p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'end' }}>
            <Button type="button" variant="ghost" onClick={handleCancel}>
              Cancelar
            </Button>
            <Button type="button" variant="danger" onClick={handleDelete}>
              Eliminar
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DeleteButton;
